import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import {API} from "../../../../config";

import Util from '../../../../yeffect/utils';

const completed_trades = API.service('completed-trades');

const styles = theme => ({
    Table:{
        '& td':{
            padding:4,
            textAlign:'right'
        }
    },
    TableHead:{
        background:'black',
        color:'white',
        '& > td':{
            padding:8,
            background:'black',
            color:'white',
            fontWeight:'bold',
            textAlign:'center'
        }
    },
    leftHead:{
      textAlign:'left'
    },
    baseRow:{
        '& > td':{
            background:theme.palette.primary.main,
            color:'white',
            fontWeight:'bold'
        }
    }
});

class Custodian extends Component {
    state = {
        brokers:[],
        buy:{},
        sell:{},
        opening:{},
        internal:{},
        error:false,
        val:0,
        vol:0,
        fee:0,
        ctn:0
    };

    totalOpening = 0;
    totalClosing = 0;

    componentDidMount() {
        const app = this;

        //calculate internal setttlements
            completed_trades.find({ query: { createdAt:{$gte:this.props.startDate +' 00:00:00', $lte:this.props.endDate +' 23:59:59'},$limit:100000,_selling_broker_id: this.props.broker._id, _buying_broker_id: this.props.broker._id}}).then(ct => {
                console.log('ict',ct);
                let cnt = ct.total;
                let val = 0;
                let vol = 0;
                let fee = 0;
                if(ct.total > 0){
                    ct.data.forEach((v,i)=>{
                        val = val + parseFloat(v._value);
                        vol = vol + parseFloat(v._quantity);
                        fee = fee + parseFloat(v._buy_commission) + parseFloat(v._sell_commission);
                    });
                    console.log('ict',val);
                    console.log('ict',vol);
                    console.log('ict',fee);
                    console.log('ict',cnt);
                    app.setState({
                        val:val,
                        vol:vol,
                        fee:fee,
                        cnt:cnt
                    })
                } else {
                    app.setState({
                        error:'No Trading',
                        val:0,
                        vol:0,
                        fee:0,
                        cnt:0
                    })
                }
            }).catch(e=>{
                console.log('Failed:',e)
            })

        /*completed_trades.find({ query: { createdAt:{$gte:this.props.startDate +' 00:00:00', $lte:this.props.endDate +' 23:59:59'},broker_id: this.props.broker._id, include:['broker'] }}).then(ct => {
            console.log('Completed Trades',ct);
            if(ct.total > 0){
                let val = 0;
                let vol = 0;
                let fee = 0;
                ct.data.forEach((v,i)=>{
                    val = val + parseFloat(v._value);
                    vol = vol + parseFloat(v._quantity);
                    fee = fee + parseFloat(v._buy_commission) + parseFloat(v._sell_commission);
                });
                app.setState({
                    val,
                    vol,
                    fee
                })
            } else {
                app.setState({
                    error:'No Trading'
                })
            }
        })*/
    }

    generateTotalOpening = () => {
        let tot = 0;
        this.state.brokers.forEach((v)=>{
            console.log(this.state.opening[v._id])
            tot = tot + this.state.opening[v._id];
        })

        return tot;
    }

    generateTotalClosing = () => {
        let tot = 0;
        this.state.brokers.forEach((v)=>{
            tot = tot + this.state.opening[v._id] + this.state.buy[v._id] - this.state.sell[v._id];
        })

        return tot;
    }

    render() {
        const { classes } = this.props

        return (
            <div className={"internal " + classes.content} style={{marginTop:10}}>
                <table className={classes.Table} style={{width:'90%'}} cellPadding={0} cellSpacing={0}>
                    <tr className={classes.TableHead}>
                        <td>&nbsp;</td>
                        <td>Trade Value</td>
                        <td># Transactions</td>
                        <td>Symbol</td>
                        <td>Volume</td>
                        <td>Fees</td>
                    </tr>

                    <tr>
                        <td colSpan="5">&nbsp;</td>
                    </tr>

                    <tr>
                        <td className={classes.leftHead}>Internal Settlements</td>
                        <td>${Util.addThousandCommas(this.state.val,'0,0.00')}</td>
                        <td>{this.state.cnt}</td>
                        <td>{this.props.broker._name}</td>
                        <td>{Util.addThousandCommas(this.state.vol,'0,')}</td>
                        <td>${Util.addThousandCommas(this.state.fee/10, '0,0.00')}</td>
                    </tr>

                    <tr>
                        <td colSpan="5">&nbsp;</td>
                    </tr>
                </table>

                <h4>Payables</h4>
                <table className={classes.Table} style={{width:'90%'}} cellPadding={0} cellSpacing={0}>
                    <tr className={classes.TableHead}>
                        <td>&nbsp;</td>
                        <td>Trade Value</td>
                        <td>Symbol</td>
                        <td>Volume</td>
                        <td>Fees</td>
                    </tr>
                    <tr>
                        <td colSpan={5} style={{textAlign:'center'}}>-- No Cross Broker Trades --</td>
                    </tr>

                    <tr>
                        <td colSpan="5">&nbsp;</td>
                    </tr>
                </table>
                <h4>Receivables</h4>
                <table className={classes.Table} style={{width:'90%'}} cellPadding={0} cellSpacing={0}>
                    <tr className={classes.TableHead}>
                        <td>&nbsp;</td>
                        <td>Trade Value</td>
                        <td>Symbol</td>
                        <td>Volume</td>
                        <td>Fees</td>
                    </tr>
                    <tr>
                        <td colSpan={5} style={{textAlign:'center'}}>-- No Cross Broker Trades --</td>
                    </tr>

                    <tr>
                        <td colSpan="5">&nbsp;</td>
                    </tr>

                    <tr><td colSpan={5}>&nbsp;</td></tr>
                    <tr className={classes.baseRow}>
                        <td className={classes.leftHead}>Fees Payable to DCSX</td>
                        <td colSpan={3}>&nbsp;</td>
                        <td>${Util.addThousandCommas(this.state.fee/10, '0,0.00')}</td>
                    </tr>

                </table>
            </div>
        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(Custodian));



// WEBPACK FOOTER //
// ./src/main/content/settlement/components/internal.js